import { addShootOutScore } from 'rcs_gaz_mc_core_FE';
import * as types from '../../lib/constants';

const initialState = {
  standing: {},
  stats: {},
  lastMatches: {},
  tableId: 'generalRanking',
};

function getTeamStats(data, teamId) {
  let teamStat;
  if (data.competitionId !== '4' && data.competitionId !== '5' && data.competitionId !== '1277') {
    teamStat = data.contents[0].competitionTeams.filter(team => Number(team.teamId) === teamId);
  } else {
    for (const group of data.contents) {
      teamStat = group.competitionTeams.filter(team => Number(team.teamId) === teamId);
      if (teamStat.length) {
        break;
      }
    }
  }
  return teamStat[0].generalRanking;
}

function setShootoutScore(lastMatches, sportId) {
  if (sportId.toString() === '1') {
    lastMatches.contents.forEach((round) => {
      round.lastMatches.forEach((matchContainer) => {
        if (matchContainer.match.resultType === 'PenaltyShootout') {
          addShootOutScore(matchContainer.match);
        }
      });
    });
  }

  return lastMatches;
}

function setCurrentSquad(data, tId) {
  const lastMatches = data && data.contents && data.contents.length > 0 && data.contents[0].lastMatches ? data.contents[0].lastMatches : [];
  if (lastMatches.length > 0 && lastMatches[0].match) {
    let team = null;
    const matchInfo = lastMatches[0].match;
    if (matchInfo && matchInfo.homeTeam && matchInfo.homeTeam.teamId && String(matchInfo.homeTeam.teamId) === String(tId)) {
      team = matchInfo.homeTeam;
    }
    if (matchInfo && matchInfo.awayTeam && matchInfo.awayTeam.teamId && String(matchInfo.awayTeam.teamId) === String(tId)) {
      team = matchInfo.awayTeam;
    }
    if (team) {
      const { teamId, teamName, teamCode } = team;
      data.currentSquad = { teamId, teamName, teamCode };
    }
  }

  return data;
}

function updateLastMatches(data, sportId, teamId) {
  setShootoutScore(data, sportId);
  setCurrentSquad(data, teamId);

  return data;
}

export default function statisticsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_STANDINGS_SUCCESS:
      return {
        ...state,
        standing: action.data,
      };
    case types.GET_STATISTICS:
      return {
        ...state,
        stats: getTeamStats(action.data, action.teamId),
      };
    case types.GET_LAST_MATCHES_SUCCESS:
      return {
        ...state,
        lastMatches: updateLastMatches(action.data, action.sportId, action.teamId),
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/demo/reducers/statistics.js